import { AppBar, Box, Toolbar } from "@mui/material";
import React from "react";
import MixedText from "../mixed-color-text";
import DrawerSm from "./drawer-sm";

const AppbarSmall = ({ handleMenuClick }) => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="sticky" className="secondary-bg">
        <Toolbar>
          <p onClick={() => handleMenuClick('/')} className="cursor-pointer">
            <MixedText first="Khurshida" second="Jahan" />{" "}
          </p>
          <Box sx={{ flexGrow: 1 }}></Box>
          <DrawerSm handleMenuClick={handleMenuClick} />
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default AppbarSmall;
